export default function getClassArrayFromHeterogeneousClassInput(classInput) {
    if (!classInput)
        return [];
    let res = [];
    if (typeof classInput === 'string') {
        const arr = classInput.split(' ');
        res = [...res, ...arr];
    }
    else if (Array.isArray(classInput)) {
        res = [...res, ...classInput];
    }
    else if (typeof classInput === 'object') {
        Object.keys(classInput).forEach(key => {
            if (classInput[key])
                res.push(key);
        });
    }
    return res;
}
